export const Messages = {
  invalid_email: 'invalid email address',
  welcome_message: 'Welcome to',
  unable_to_process: 'We were unable to process your request',
  sign_in_warning: 'Please contact your administrator for further assistance.',
  read_terms: "By continuing, you're confirming that \n you've read our",
  terms_of_service: ' Terms of Service',
  no_results: 'We couldn’t find any results. Please try again.',
  view_results: 'View all results with',
  input_warning: 'Please input at least three characters'
}
